export const Operator = {
  EQUAL_TO: "eq",
  GREATER_THAN_EQUAL_TO: "gte",
  LESS_THAN_EQUAL_TO: "lte",
  NOT_EQUAL_TO: "neq",
  LESS_THAN: 'lt',
}

export const createFilter = (property, operator, values) => ({ property, operator, values })
